import React from "react";
import { Formik, FormikProps } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { Input, SubmitButton, CheckBox } from "./Components";
import { Form, MainWrapper, Error } from "./app.style";
import moment from 'moment';

const getValidationSchema: (cakeList: cake[]) => any = (cakeList) => {
  var schema: any = {
    LastName: Yup.string()
      .required("is required")
      .max(250, "Last Name must be less that 255 characters."),
    FirstName: Yup.string()
      .required("is required")
      .max(250, "First must be less that 255 characters."),
    AddressLine1: Yup.string()
      .required("is required")
      .max(250, "Address Line 1 must be less that 255 characters."),
    AddressLine2: Yup.string().max(
      250,
      "Address Line 2 must be less that 255 characters."
    ),
    City: Yup.string()
      .required("is required")
      .max(250, "City must be less that 255 characters."),
    County: Yup.string()
      .required("is required")
      .max(250, "County must be less that 255 characters."),
    PostCode: Yup.string()
      .required("is required")
      .max(250, "Post Code must be less that 255 characters."),
    Country: Yup.string()
      .required("is required")
      .max(250, "Country must be less that 255 characters."),
    Email: Yup.string()
      .required("Email is required")
      .email()
      .max(250, "Email must be less that 255 characters."),
    Phone: Yup.string()
      .required("Phone is required")
      .max(250, "Phone must be less that 255 characters."),
    OrderCakes: Yup.bool(),
    OrderVouchers: Yup.bool(),
    HaveVoucherNo: Yup.bool(),
    HaveVoucherYes: Yup.bool(),
    numberOfVouchers: Yup.number().when("OrderVouchers", {
      is: true,
      then: Yup.number()
        .required("Number Of Vouchers is required")
        .min(1, "Number Of Vouchers must be greater than or equal to 1"),
    }),
    mailVouchers: Yup.string().when("OrderVouchers", {
      is: true,
      then: Yup.string().email(),
    }),
    valueOfVouchers: Yup.number().when("OrderVouchers", {
      is: true,
      then: Yup.number()
        .required("Order Vouchers is required")
        .min(1, "Order Vouchers must be greater than or equal to 1"),
    }),
    VoucherId: Yup.string().when("HaveVoucher", {
      is: true,
      then: Yup.string().required("Have Voucher is required"),
    }),
    colletionType: Yup.string().when("OrderCakes", {
      is: true,
      then: Yup.string().required(
        "Please select how you’d like to receive your order."
      ),
    }),

    collectionDate: Yup.string().when("colletionType", {
      is: "collected",
      then: Yup.string().required("Select your collection Date."),
    }),

    deliveryDate: Yup.string().when("colletionType", {
      is: "delivered",
      then: Yup.string().required("Select your delivery Date."),
    }),

    deliveryAddress: Yup.string().when("colletionType", {
      is: "delivered",
      then: Yup.string().required("Select your delivery address."),
    }),

    DeliveryAddressLine1: Yup.string().when(
      ["colletionType", "deliveryAddress"],
      {
        is: (colletionType, deliveryAddress) => {
          return (
            colletionType === "delivered" &&
            deliveryAddress === "deliveryNewAddress"
          );
        },
        then: Yup.string()
          .required("Address Line 1 is required")
          .max(250, "Address Line 1 must be less that 255 characters."),
      }
    ),

    DeliveryAddressLine2: Yup.string().when(
      ["colletionType", "deliveryAddress"],
      {
        is: (colletionType, deliveryAddress) => {
          return (
            colletionType === "delivered" &&
            deliveryAddress === "deliveryNewAddress"
          );
        },
        then: Yup.string().max(
          250,
          "Address Line 2 must be less that 255 characters."
        ),
      }
    ),

    DeliveryCity: Yup.string().when(["colletionType", "deliveryAddress"], {
      is: (colletionType, deliveryAddress) => {
        return (
          colletionType === "delivered" &&
          deliveryAddress === "deliveryNewAddress"
        );
      },
      then: Yup.string()
        .required("City is required")
        .max(250, "City must be less that 255 characters."),
    }),

    DeliveryCounty: Yup.string().when(["colletionType", "deliveryAddress"], {
      is: (colletionType, deliveryAddress) => {
        return (
          colletionType === "delivered" &&
          deliveryAddress === "deliveryNewAddress"
        );
      },
      then: Yup.string()
        .required("County is required")
        .max(250, "County must be less that 255 characters."),
    }),

    DeliveryPostCode: Yup.string().when(["colletionType", "deliveryAddress"], {
      is: (colletionType, deliveryAddress) => {
        return (
          colletionType === "delivered" &&
          deliveryAddress === "deliveryNewAddress"
        );
      },
      then: Yup.string()
        .required("Post Code is required")
        .max(250, "Post Code must be less that 255 characters."),
    }),

    DeliveryCountry: Yup.string().when(["colletionType", "deliveryAddress"], {
      is: (colletionType, deliveryAddress) => {
        return (
          colletionType === "delivered" &&
          deliveryAddress === "deliveryNewAddress"
        );
      },
      then: Yup.string()
        .required("Country is required")
        .max(250, "Country must be less that 255 characters."),
    }),
  };

  cakeList.forEach(
    (cake) =>
    (schema[`${cake.name}_value`] = Yup.number().when(`${cake.name}_check`, {
      is: true,
      then: Yup.number().min(
        cake.minValues,
        `Please choose ${cake.minValues} or more ${cake.name}.`
      ),
    }))
  );

  var OrderTypeValidation: any = {
    name: "OrderTypeValidation",
    message: null,
    test: (obj: any) => {
      if (obj.OrderCakes || obj.OrderVouchers) {
        return true;
      }

      return new Yup.ValidationError(
        "Check at least one Order Type",
        null,
        "OrderTypeValidation"
      );
    },
  };

  return Yup.object().shape(schema).test(OrderTypeValidation);
};

var getInitialValues: (cakeList: any[]) => any = (cakeList) => {
  var initialValues: any = {
    LastName: "",
    FirstName: "",
    AddressLine1: "",
    AddressLine2: "",
    City: "",
    County: "",
    PostCode: "",
    Country: "",
    Email: "",
    Phone: "",
    OrderCakes: false,
    OrderVouchers: false,
    SoyaAlergy: false,
    GlutenAlergy: false,
    HaveVoucher: false,
    VoucherId: "",
    numberOfVouchers: 0,
    mailVouchers: "",
    valueOfVouchers: 0,
    colletionType: "",
    deliveryAddress: "",
    DeliveryAddressLine1: "",
    DeliveryAddressLine2: "",
    DeliveryCity: "",
    DeliveryCounty: "",
    DeliveryPostCode: "",
    DeliveryCountry: "",
    deliveryDate: new Date(),
    collectionDate: new Date(),
  };

  cakeList.forEach((cake) => (initialValues[`${cake.name}_check`] = false));
  cakeList.forEach((cake) => (initialValues[`${cake.name}_value`] = 0));

  return initialValues;
};

interface cake {
  name: string;
  price: string;
  minValues: number;
}

interface IAppProps { }

const App: React.FC<IAppProps> = (props: IAppProps) => {
  var cakeList: cake[] = [

    { name: "Chocolate Chip Cookies", price: "2.00", minValues: 6 },
    { name: "Blueberry Lemon Squares", price: "2.50", minValues: 6 },
    { name: "Chocolate Peanut Crispy Cakes", price: "2.50", minValues: 6 },
    { name: "Chocolate Brownies", price: "2.50", minValues: 6 },
    { name: "Chocolate Sponge", price: "16.50", minValues: 1 },
    { name: "Victoria Sandwich", price: "16.00", minValues: 1 },
    { name: "Lemon Drizzle Cake", price: "14.50", minValues: 1 },
    { name: "Lemon Drizzle loaf", price: "7.75", minValues: 1 },
    { name: "Cherry Almond Slices", price: "2.50", minValues: 6 },
    { name: "Carrot Cake", price: "17.00", minValues: 1 },

    { name: "Lemon and Poppy Seeds Sponge", price: "16.50", minValues: 1 },
    { name: "Coffee and Walnut Sponge", price: "16.50", minValues: 1 },

    { name: "Birthday Cakes", price: "22.99", minValues: 1 },

    { name: "Afternoon Tea - Sweet Option", price: "10.50", minValues: 1 },
    { name: "Afternoon Tea - Savoury Option", price: "10.50", minValues: 1 },
    { name: "Cupcakes", price: "2.50", minValues: 1 },

    { name: "Christmas Pudding", price: "3.25", minValues: 1 },
    { name: "4 Mince Pies", price: "2.75", minValues: 1 },
    { name: "Christmas Cake", price: "20.50", minValues: 1 },

  ];
  var validationSchema = getValidationSchema(cakeList);

  var baseUrl = "https://rachelsvegancakes.co.uk/api";

  const sendEmail: (data: any, reset: () => void) => void = (data, reset) => {
    axios
      .post(`${baseUrl}/?controller=mail`, data)
      .then((response) => {
        if (response.data) {
          reset();
          window.parent.parent.scrollTo(0, 0);
          alert(
            "Order Sent. Your order details have been sent to your email address. Rachel will be in touch shortly."
          );
        }
      })
      .catch(() => {
        alert("Order Not Sent.");
      });
  };

  const getRachelEmail: (data: any) => string = (data: any) => {
    return `<html><head><style>.p{color:red}</style></head><body>${buildInfoBody(data)}</body></html>`;
  }

  const getCustomerEmail: (data: any) => string = (data: any) => {

    const salutation = `<p>Hi ${data["FirstName"]} "  ${data["LastName"]}, Thank you for your order.</p>`;
    const end = "<p>Rachel will be in touch to discuss your order.</p>";
    let msg = "";

    const pc = data["deliveryAddress"] === "deliveryNewAddress" ? data["DeliveryPostCode"] : data["PostCode"];

    if (data["OrderCakes"] && data["colletionType"] === "delivered") {

      if (pc.toUpperCase().indexOf('LL') !== -1 && pc.toUpperCase().indexOf('CH') !== -1) {
        msg = `<p>You have chosen to have your cakes delivered but your post code ${pc} MAY be outside of our delivery radius + </p>`;
      }
    }


    if (data["OrderVouchers"] && !data["OrderCakes"]) {
      msg = msg + `<p>Your gift voucher will be sent via email to ${data["Email"]}</p>`;
    }

    // if (data["OrderCakes"] && !data["OrderVouchers"] && data["colletionType"]==="collected") {

    // }

    if (data["OrderCakes"] && !data["OrderVouchers"] && data["colletionType"] === "delivered") {
      msg = msg + `<p>Your order will be sent to :</p> ${getAddressClient(data)}`;
    }

    let details = "<h3>Order Details</h3>";
    details = details + buildInfoBody(data);

    return salutation + msg + end + details;
  }

  const getAddressClient: (data: any) => string = (data: any) => {

    let addr = "";
    if (data["deliveryAddress"] === "deliveryNewAddress") {
      addr = addr + data["DeliveryAddressLine1"];
      addr = addr + "<br/>" + data["DeliveryAddressLine2"];
      addr = addr + "<br/>" + data["DeliveryCity"];
      addr = addr + "<br/>" + data["DeliveryCounty"];
      addr = addr + "<br/>" + data["DeliveryCountry"];
      addr = addr + "<br/>" + data["DeliveryPostCode"];
    } else {
      addr = addr + data["AddressLine1"];
      addr = addr + "<br/>" + data["AddressLine2"];
      addr = addr + "<br/>" + data["City"];
      addr = addr + "<br/>" + data["County"];
      addr = addr + "<br/>" + data["Country"];
      addr = addr + "<br/>" + data["PostCode"];
    }

    return addr;
  }

  const getAddress: (data: any) => string = (data: any) => {

    let addr = "";
    addr = addr + data["AddressLine1"];
    addr = addr + "<br/>" + data["AddressLine2"];
    addr = addr + "<br/>" + data["City"];
    addr = addr + "<br/>" + data["County"];
    addr = addr + "<br/>" + data["Country"];
    addr = addr + "<br/>" + data["PostCode"];

    return addr;
  }

  const getDeliveryAddress: (data: any) => string = (data: any) => {

    let addr = "";
    addr = addr + data["DeliveryAddressLine1"];
    addr = addr + "<br/>" + data["DeliveryAddressLine2"];
    addr = addr + "<br/>" + data["DeliveryCity"];
    addr = addr + "<br/>" + data["DeliveryCounty"];
    addr = addr + "<br/>" + data["DeliveryCountry"];
    addr = addr + "<br/>" + data["DeliveryPostCode"];

    return addr;
  }

  const GetRow: (title: string, value: string, even: boolean) => string =
    (title: string, value: string, even: boolean) => {
      if (even) {
        return `<tr> ${GetTitle(title)} ${GetValue(value)} </tr>`;
      } else {
        return `<tr style="background-color: #dddddd;">${GetTitle(title)} ${GetValue(value)}</tr> `;
      }
    }

  const GetTitle: (title: string) => string = (title: string) => {
    return `<th style="text-align: left;color:#222;padding: 8px;">${title}</th>`;
  }

  const GetOrderType: (orderType: string) => string = (orderType: string) => {
    if (orderType === "collected") {
      return "Collection";
    } else {
      return "Delivery";
    }
  }

  const GetValue: (value: string) => string = (value: string) => {
    return `<td style="text-align: left;color:#333;padding: 8px;">${value}</td>`;
  }

  const buildInfoBody: (data: any) => string = (data: any) => {
    let odd = false;
    let body = '';
    body = body + `<table style="border-collapse: collapse">`;
    body = body + GetRow("Name", data["FirstName"] + " " + data["LastName"], odd);
    odd = !odd;
    body = body + GetRow("Email", data["Email"], odd);
    odd = !odd;
    body = body + GetRow("Phone", data["Phone"], odd);
    odd = !odd;

    body = body + GetRow("Address", getAddress(data), odd);
    odd = !odd;

    if (data["OrderCakes"]) {
      body = body + GetRow("Order Type", GetOrderType(data["colletionType"]), odd);
      odd = !odd;
    }

    if (data["deliveryAddress"] === "deliveryNewAddress") {
      body = body + GetRow("Delivery Address", getDeliveryAddress(data), odd);
      odd = !odd;
    }

    if (data["OrderCakes"] && data["colletionType"] === "delivered") {
      body = body + GetRow("Delivery Date", moment(data["deliveryDate"]).format('DD-MM-YYYY'), odd);
      odd = !odd;
    }

    if (data["OrderCakes"] && data["colletionType"] === "collected") {
      body = body + GetRow("Collection Date", moment(data["collectionDate"]).format('DD-MM-YYYY'), odd);
      odd = !odd;
    }

    if (data["GlutenAlergy"]) {
      body = body + GetRow("Gluten Free", "Yes", odd);
      odd = !odd;
    } else {
      body = body + GetRow("Gluten Free", "No", odd);
      odd = !odd;
    }

    if (data["SoyaAlergy"]) {
      body = body + GetRow("Soya Free", "Yes", odd);
      odd = !odd;
    } else {
      body = body + GetRow("Soya Free", "No", odd);
      odd = !odd;

    }

    if (data["OrderCakes"]) {
      let cakes = GetCakes(data, odd);
      body = body + cakes[0];
      odd = cakes[1];
    }

    if (data["OrderVouchers"]) {
      body = body + GetRow("Number Of Vouchers", data["numberOfVouchers"], odd);
      odd = !odd;
      body = body + GetRow("Value Of the Vouchers", data["valueOfVouchers"], odd);
      odd = !odd;
      body = body + GetRow("Email For Vouchers", data["mailVouchers"], odd);
      odd = !odd;
    }

    if (data["HaveVoucher"]) {
      body = body + GetRow("Have Voucher", data["HaveVoucher"], odd);
      odd = !odd;
      body = body + GetRow("Voucher Id", data["VoucherId"], odd);
      odd = !odd;
    }

    body = body + "</table>";

    return body;
  }


  const GetCakes: (data: any, odd: boolean) => any[] = (data: any, odd: boolean) => {
    let keys = Object.keys(data);
    let cakes = "";

    keys.forEach(
      (key: string) => {
        if (!key.indexOf('check') && data[key]) {
          let keyName = key.replace("_check", "");
          cakes = cakes + GetRow(keyName, data[keyName + "_value"], odd);
          odd = !odd;
        }
      }
    );

    return [cakes, odd];
  }



  return (
    <MainWrapper>
      {/* <p>To order your cakes please email <a href='mailto: rachel@rachelsvegancakes.co.uk'>rachel@rachelsvegancakes.co.uk</a></p>

      <p>We are currently working on the online order form</p> */}
      <Formik
        initialValues={getInitialValues(cakeList)}
        enableReinitialize={true}
        validationSchema={validationSchema}
        onSubmit={(values, actions) => {
          sendEmail(values, actions.resetForm);
        }}
      >
        {(props: FormikProps<any>) => (
          <Form onSubmit={props.handleSubmit}>
            <h3>Order Form</h3>
            <h5>Please complete all fields to assist us with your order.</h5>
            <hr />
            <Input required name="FirstName" type="text" label="First Name" />
            <Input required name="LastName" type="text" label="Last Name" />
            <Input
              required
              name="AddressLine1"
              type="text"
              label="Address Line 1"
            />
            <Input name="AddressLine2" type="text" label="Address Line 2" />
            <Input required name="City" type="text" label="City" />
            <Input required name="County" type="text" label="County" />
            <Input required name="PostCode" type="text" label="Post Code" />
            <Input required name="Country" type="text" label="Country" />
            <Input required name="Email" type="text" label="Email" />
            <Input required name="Phone" type="text" label="Phone Number" />

            <h3>Your Order</h3>
            <h5>What will you be ordering today?</h5>
            <hr />
            <CheckBox name="OrderCakes" label="Cakes" />
            <CheckBox name="OrderVouchers" label="Gift Vouchers" />
            <Error>{props.errors.OrderTypeValidation}</Error>

            {props.values.OrderCakes && (
              <div>
                <h3>Your Cakes</h3>
                <h5>Please select the cakes you would like to order:</h5>
                <hr />
                {cakeList.map((cake) => (
                  <CheckBox
                    key={`${cake.name}_check`}
                    name={`${cake.name}_check`}
                    label={cake.name}
                  />
                ))}
                {cakeList.some((e) => props.values[`${e.name}_check`]) && (
                  <div>
                    <h3>Quantities</h3>
                    <hr />
                  </div>
                )}
                {cakeList.map((cake) => {
                  if (props.values[`${cake.name}_check`]) {
                    return (
                      <Input
                        required
                        key={`${cake.name}_value`}
                        name={`${cake.name}_value`}
                        type="number"
                        label={cake.name}
                        suffix={`£${cake.price} each`}
                        info={`Minimum of ${cake.minValues}`}
                      />
                    );
                  }
                })}

                {props.values.OrderCakes && (
                  <div>
                    <h3>I'd like to:</h3>
                    <hr />
                    <CheckBox
                      value="delivered"
                      checked={props.values.colletionType === "delivered"}
                      onChange={() =>
                        props.setFieldValue("colletionType", "delivered")
                      }
                      name="delivered"
                      label="Have my cakes delivered."
                    />
                    <CheckBox
                      value="collected"
                      checked={props.values.colletionType === "collected"}
                      onChange={() =>
                        props.setFieldValue("colletionType", "collected")
                      }
                      name="collected"
                      label="Collect my cakes."
                    />
                    <Error>{props.errors.colletionType}</Error>

                    {props.values.colletionType === "collected" && (
                      <div>
                        <Input
                          required
                          name="collectionDate"
                          type="date"
                          label="Collection Date"
                        />
                      </div>
                    )}

                    {props.values.colletionType === "delivered" && (
                      <div>
                        <Input
                          required
                          name="deliveryDate"
                          type="date"
                          label="Delivery Date"
                        />

                        <h3>I'd like to:</h3>
                        <hr />
                        <CheckBox
                          value="deliverySameAddress"
                          checked={
                            props.values.deliveryAddress ===
                            "deliverySameAddress"
                          }
                          onChange={() =>
                            props.setFieldValue(
                              "deliveryAddress",
                              "deliverySameAddress"
                            )
                          }
                          name="deliverySameAddress"
                          label="Use same address as above."
                        />
                        <CheckBox
                          value="deliveryNewAddress"
                          checked={
                            props.values.deliveryAddress ===
                            "deliveryNewAddress"
                          }
                          onChange={() =>
                            props.setFieldValue(
                              "deliveryAddress",
                              "deliveryNewAddress"
                            )
                          }
                          name="deliveryNewAddress"
                          label="Deliver to a different address."
                        />
                        <Error>{props.errors.deliveryAddress}</Error>

                        {props.values.deliveryAddress ===
                          "deliveryNewAddress" && (
                            <div>
                              <h3>Delivery Address:</h3>
                              <hr />

                              <Input
                                required
                                name="DeliveryAddressLine1"
                                type="text"
                                label="Address Line 1"
                              />
                              <Input
                                name="DeliveryAddressLine2"
                                type="text"
                                label="Address Line 2"
                              />
                              <Input
                                required
                                name="DeliveryCity"
                                type="text"
                                label="City"
                              />
                              <Input
                                required
                                name="DeliveryCounty"
                                type="text"
                                label="County"
                              />
                              <Input
                                required
                                name="DeliveryPostCode"
                                type="text"
                                label="Post Code"
                              />
                              <Input
                                required
                                name="DeliveryCountry"
                                type="text"
                                label="Country"
                              />
                            </div>
                          )}
                      </div>
                    )}
                  </div>
                )}

                <h3>Other Requirements</h3>
                <hr />
                <CheckBox name="SoyaAlergy" label="Soya Free" />
                <CheckBox name="GlutenAlergy" label="Gluten Free" />
              </div>
            )}

            {props.values.OrderVouchers && (
              <div>
                <h3>Gift Vouchers</h3>
                <h5>
                  Please select number of gift vouchers below and choose an
                  amount per voucher
                </h5>
                <hr />
                <Input
                  required
                  name="numberOfVouchers"
                  type="number"
                  label="Number of Vouchers"
                />
                <Input
                  required
                  name="valueOfVouchers"
                  type="number"
                  prefix="£"
                  min="0.00"
                  max="10000.00"
                  step="0.01"
                  label="Value of the Vouchers"
                />
                <Input
                  name="mailVouchers"
                  type="text"
                  label="Vouchers are sent via email + Please state the email address for your voucher to be sent to (if different from current)"
                />
              </div>
            )}

            <h5>Do you have a voucher code?</h5>
            <hr />
            <CheckBox name="HaveVoucher" label="I have a voucher." />
            {props.values.HaveVoucher && (
              <Input
                required
                name="VoucherId"
                type="text"
                label="Enter your voucher code here"
                info="Seperate any voucher codes with a space"
              />
            )}
            <SubmitButton />
          </Form>
        )}
      </Formik>
    </MainWrapper>
  );
};

export default App;